import { ROUTES } from "../routes";
import axios from "axios";
import { handleMalwareDetection, isMalwareDetected } from "./security";

export const sendEmail = async (data: any) => {
  try {
    const response = await axios.post(ROUTES.SEND_MAIL, data, {
      withCredentials: true,
      timeout: 60000,
      maxContentLength: 50 * 1024 * 1024,
      maxBodyLength: 50 * 1024 * 1024,
    });
    return response.data;
  } catch (error) {

    if (axios.isAxiosError(error)) {
      if (isMalwareDetected(error.response?.status || 0)) {
        return await handleMalwareDetection();
      }

      if (error.code === 'ECONNABORTED') {
        throw new Error('Request timeout - file might be too large');
      }
      if (error.response?.status === 413) {
        throw new Error('File too large for server');
      }
      if (error.response?.status === 400) {
        throw new Error('Invalid request format');
      }
    }
    throw error;
  }
};